export default {"src":"__ASTRO_ASSET_IMAGE__$pAei$02__","width":386,"height":88,"format":"svg"}